import Marquee from "react-fast-marquee";

const ITEMS = ["SYNERGY SOLAR", "COMPLETE SOLAR EPC", "25-YEAR WARRANTY", "TIER-1 PANELS", "ENERGIZING LIFE", "ZERO-DOWN FINANCING", "PM SURYA GHAR SUBSIDY", "TRICITY LEADER"];

export default function TickerMarquee() {
  return (
    <div data-testid="marquee" className="border-y border-forest/15 bg-forest py-5">
      <Marquee speed={40} gradient={false} autoFill>
        {ITEMS.map((t, i) => (
          <span key={i} className="mx-8 font-mono text-sm uppercase tracking-[0.25em] text-cream/80">
            {t} <span className="ml-8 text-gold">✦</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
